"use client";

import { useState } from "react";
import Link from "next/link";
import { services } from "@/data/dummy";

export default function ServicesDropdown() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      onMouseEnter={() => setIsOpen(true)}
      onMouseLeave={() => setIsOpen(false)}
    >
      {/* Services Trigger Button */}
      <button className="nav-button flex items-end gap-1">
        Services
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="currentColor"
          className={`transform transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
        >
          <path
            fillRule="evenodd"
            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
          />
        </svg>
      </button>

      {/* Dropdown Content */}
      {isOpen && (
        <div
          className="
            absolute left-0 right-0 w-screen bg-white p-4 md:p-8 mt-0 border-gray-200 shadow-lg z-50
            origin-top
            animate-dropdown
            "
        >
          <div className="max-w-7xl mx-auto md:px-20">
            <div className="grid grid-cols-2 gap-4">
              {/* Service Cards */}
              {services.slice(0, 4).map((service) => (
                <Link
                  key={service.title}
                  href={`/services/${service.id}`}
                  className="group flex gap-3 items-center border border-gray-200 hover:border-cyan-300 hover:shadow-md transition-all duration-200 overflow-hidden bg-white "
                  onClick={() => setIsOpen(false)}
                >
                  {/* Left: Image */}
                  <div className="relative h-28 w-28 overflow-hidden p-2 shrink-0">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute inset-0 bg-linear-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 "></div>
                  </div>

                  {/* Right: Content */}
                  <div className="pr-3 py-3 flex-1">
                    <h4 className="font-semibold text-gray-900 group-hover:text-cyan-600 transition-colors mb-1 text-sm">
                      {service.title}
                    </h4>

                    <p className="text-xs text-gray-600 line-clamp-2 leading-relaxed">
                      {service.description}
                    </p>

                    {/* <Link href="/about"> */}
                    <div className="flex items-center mt-2 text-cyan-600 text-xs font-medium">
                      Learn more
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 16 16"
                        className="ml-1 group-hover:translate-x-0.5 transition-transform"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </div>
                    {/* </Link> */}
                  </div>
                </Link>
              ))}
            </div>

            {/* View All Link */}
            <div className="mt-4 pt-3 border-t border-gray-200 text-center">
              <Link
                href="/services"
                className="inline-flex items-center text-cyan-600 hover:text-cyan-700 font-medium text-xs"
                onClick={() => setIsOpen(false)}
              >
                View all services
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 16 16"
                  className="ml-1"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  />
                </svg>
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
